import { useLocalization } from '@magicdoor/ui';
import { createMemo, For } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { Button } from '~/components/common/Buttons';
import { IconLink, IconLock } from '~/components/ui';
import { useAuth } from '~/contexts/global';
import { cn } from '~/utils/classnames';
import { LoginType } from '~/utils/constant';
import type { Component } from 'solid-js';

type ButtonOption = {
  type: LoginType;
  icon: Component<{ class?: string }>;
  label: string;
};

export const RestLoginType = (props: { class?: string }) => {
  const { t } = useLocalization();
  const { setLoginType, loginType } = useAuth();

  const buttons = createMemo(
    () =>
      [
        {
          type: LoginType.MagicLink,
          icon: IconLink,
          label: t('Sign in with magic link'),
        },
        //NOTE - Phone number login is not supported yet,cause property manager don't have phone number
        // {
        //   type: LoginType.Otp,
        //   icon: IconPhone,
        //   label: t('Sign in with phone number'),
        // },
        {
          type: LoginType.Password,
          icon: IconLock,
          label: t('Sign in with account'),
        },
      ].filter((button) => button.type !== loginType()) as ButtonOption[]
  );

  const handleChangeLoginType = (button: ButtonOption) => {
    setLoginType(button.type);
  };

  return (
    <div class={cn('flex flex-col gap-2', props.class)}>
      <For each={buttons()}>
        {(button) => (
          <Button variant="outlined" rounded="full" class="flex justify-center" onClick={() => handleChangeLoginType(button)}>
            <Dynamic component={button.icon} class="size-5" />
            <span>{button.label}</span>
          </Button>
        )}
      </For>
    </div>
  );
};
